import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
import { CreateTimeReportingProjectFooterProps } from "models/propTypes/timeReportingProjectPropTypes";
//#endregion
//#region components
import { WizardFooter } from "components/common";
//#endregion

const CreateTimeReportingProjectFooter: React.FC<CreateTimeReportingProjectFooterProps> = (props) => {
  const { submitForm, isFormValid, onSubmitSuccess } = props;
  return (
    <WizardFooter
      actions={[
        {
          text: TranslationKeys.TimeReportingProject.SaveTimeReportingProject,
          type: StyleEnums.DisplayType.Success,
          successMessage: TranslationKeys.TimeReportingProject.CreatedMessage,
          onClick: submitForm,
          onActionSuccess: onSubmitSuccess,
          isDisabled: !isFormValid,
        },
      ]}
    />
  );
};

export default CreateTimeReportingProjectFooter;
